<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <!-- 题目类型标签 -->
    <div class="question-type">手写签名</div>

    <!-- 题目标题 -->
    <div class="title-view">
      <!-- <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">{{ dataObj.caseProblem }}</span>
      </span> -->
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <!-- 题目封面图片 -->
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%; border-radius: 4px" />
      </div>
    </div>

    <!-- 签名区域：未签名/已签名状态 -->
    <div
      v-if="!dataObj.signatureImage"
      class="sign-view"
      @click="handleSignClick"
    >
      <img
        src="https://ossfastmake.mustke.com/wenjuan/tupian/signature-1767493390422.svg"
        class="sign-image"
      />
      <span class="sign-text">点击此处签名</span>
    </div>
    <div v-else class="sign-view" @click="handleSignClick">
      <img
        :src="dataObj.signatureImage"
        style="width: 100%; height: 220px; object-fit: contain"
      />
    </div>

    <!-- 图片预览弹窗（替代原fangda-popup） -->
    <el-dialog
      title="图片预览"
      :visible.sync="fangdaShow"
      width="60%"
      @close="fangdaClose"
      append-to-body
    >
      <div class="popup-scroll">
        <img :src="fangdaImgUrl" style="width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 引入Web端手写签名插件（核心依赖）
export default {
  name: "QuestionSignatureView",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataObj: {},
      answerObj: {},
      index: 0,
      startColor: { r: 58, g: 96, b: 255 },
      endColor: { r: 58, g: 96, b: 255 },
      themeColor: { r: 58, g: 96, b: 255 },
      images: [],
      signatureImage: "",
      showSign: false, // 签名弹窗开关
      // 替代Vue3 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      // 签名插件实例
      signaturePadInstance: null,
    };
  },
  // Vue2 监听属性
  watch: {
    params: {
      handler(newValue) {
        // 深拷贝避免引用问题
        this.dataObj = { ...newValue.data };
        this.index = newValue.index || 0;
        // 解析封面图片（容错：空值时解析为空数组）
        this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
        // 初始化签名图片
        this.signatureImage = newValue.data.signatureImage || "";
        this.dataObj.signatureImage = this.signatureImage;
      },
      immediate: true, // 初始化立即执行
      deep: true, // 深度监听对象变化
    },
  },
  mounted() {
    // 初始化手写签名插件
    this.initSignaturePad();
  },
  methods: {
    // 初始化签名画板
    initSignaturePad() {
      const canvas = this.$refs.signaturePad;
      if (canvas) {
        // 适配Canvas尺寸
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        // 创建签名实例
        this.signaturePadInstance = new SignaturePad(canvas, {
          penColor: "rgb(58, 96, 255)", // 签名颜色匹配主题色
          minWidth: 1,
          maxWidth: 2,
        });
      }
    },
    // 关闭图片预览弹窗
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
    // 点击签名区域
    handleSignClick() {
      // 仅在状态为3/4时允许签名
      if ([3, 4].includes(this.dataObj.status)) {
        this.showSign = true;
        // 触发页面滚动禁用事件（Web端可通过CSS实现：body { overflow: hidden; }）
        this.$emit("disablePageScroll", true);
        // 重新初始化签名画板（避免弹窗尺寸变化导致签名错位）
        this.$nextTick(() => this.initSignaturePad());
      }
    },
    // 确认签名（核心逻辑）
    confirmSign() {
      if (!this.signaturePadInstance) return;

      // 获取签名图片Base64
      const img = this.signaturePadInstance.toDataURL("image/png");
      console.log("签字图片：", img);

      // 更新签名状态
      this.signatureImage = img;
      this.dataObj.signatureImage = img;

      // 构造答案对象
      this.answerObj = {
        question_id: this.dataObj.id,
        type: this.dataObj.type,
        answer: [{ id: "", context: img }],
        if_hide: this.dataObj.if_hide,
      };

      // 触发更新事件
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          index: this.index,
          answer: this.answerObj,
        }),
      );

      // 关闭签名弹窗
      this.showSign = false;
      this.$emit("disablePageScroll", false);
    },
    // 重置签名
    signReset() {
      console.log("重置签名");
      if (this.signaturePadInstance) {
        this.signaturePadInstance.clear(); // 清空签名画板
      }
      this.signatureImage = "";
      // 如需触发重置后的更新事件，可取消下方注释
      // this.$emit('update', JSON.stringify({
      //   data: this.dataObj,
      //   index: this.index,
      //   answer: {
      //     question_id: this.dataObj.id,
      //     type: this.dataObj.type,
      //     answer: [{ id: "", context: "" }],
      //     if_hide: this.dataObj.if_hide
      //   }
      // }))
    },
    // 关闭签名弹窗
    handleClose() {
      this.showSign = false;
      this.$emit("disablePageScroll", false);
    },
  },
};
</script>

<style lang="scss" scoped>
// 核心容器
.question-container {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 15px;
}

// 封面图片区域
.question-images {
  margin-bottom: 10px;

  img {
    max-width: 100%;
    border-radius: 4px;
  }
}

// 签名区域
.sign-view {
  width: 100%;
  height: 220px; // 440rpx → 220px
  border: 1px solid #dcdde0;
  border-radius: 4px; // 8rpx → 4px
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f6f6f6;
  margin-top: 10px; // 20rpx → 10px
  cursor: pointer; // Web端添加点击反馈
  overflow: hidden;

  .sign-image {
    width: 26px; // 52rpx → 26px
    height: 27px; // 54rpx → 27px
    margin-top: 90px; // 180rpx → 90px
  }

  .sign-text {
    font-size: 14px; // 28rpx → 14px
    font-weight: 400;
    text-align: center;
    color: #798497;
    margin-top: 11px; // 22rpx → 11px
  }
}

// 预览弹窗内容
.popup-scroll {
  width: 100%;
  padding: 10px;

  img {
    max-width: 100%;
    max-height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewSignature.vue